import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
    SettingsUsersFormCard,
    SettingsUsersFormFeedback,
    SettingsUsersFormFields,
} from './components/settings-users-form/components';
import { useSettingsUsersEditForm } from './components/settings-users-form/hooks';

export const SettingsUsersEditScreen = () => {
    const navigate = useNavigate();
    const { userId } = useParams();
    const { token, id: currentUserId } = useSelector((state) => state.auth);

    const {
        form,
        isLoading,
        isSaving,
        error,
        successMessage,
        handleInputChange,
        handleStatusChange,
        handleSubmit,
    } = useSettingsUsersEditForm({ token, userId, currentUserId });

    return (
        <SettingsUsersFormCard
            title="Editar usuario"
            onBack={() => navigate('/settings/users')}
        >
            <SettingsUsersFormFeedback error={error} successMessage={successMessage} />

            {isLoading ? (
                <div className="text-muted">Cargando usuario...</div>
            ) : (
                <form onSubmit={handleSubmit}>
                    <SettingsUsersFormFields
                        form={form}
                        onInputChange={handleInputChange}
                        includeStatus
                        onStatusChange={handleStatusChange}
                        includePassword
                    />

                    <div className="mt-4 d-flex gap-2">
                        <button type="submit" className="btn btn-primary" disabled={isSaving}>
                            {isSaving ? 'Guardando...' : 'Guardar cambios'}
                        </button>
                        <button type="button" className="btn btn-light-brand" onClick={() => navigate('/settings/users')}>
                            Cancelar
                        </button>
                    </div>
                </form>
            )}
        </SettingsUsersFormCard>
    );
};
